import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=5fee9efe&scoped=true"
import script from "./Ellipsis.vue?vue&type=script&lang=js"
export * from "./Ellipsis.vue?vue&type=script&lang=js"
import style0 from "./Ellipsis.vue?vue&type=style&index=0&id=5fee9efe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee9efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fee9efe')) {
      api.createRecord('5fee9efe', component.options)
    } else {
      api.reload('5fee9efe', component.options)
    }
    module.hot.accept("./Ellipsis.vue?vue&type=template&id=5fee9efe&scoped=true", function () {
      api.rerender('5fee9efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Ellipsis.vue"
export default component.exports